export const text = {
  pageTitle: "End User Agreement",
  updateMessage: "End User Agreement Updated Successfully",
  endUserAgreement: "End User License Agreement Daakia",
};
